import Button from '../base/button';

import {registerMPElement} from '../../util/register-element';

import template from './index.jade';

import css from './index.styl?inline';

// TODO (lkloh): Cut over to using theme-based styling instead of attributes
// like "isBlue|isRed|isGrey" when we upgrade to using new icons everywhere
const THEMES = [
  `primary`,
  `secondary`,
  `subtle`,
  `tertiary`,
];

export default registerMPElement(`mp-button`, class extends Button {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'class': `string`,
      'color': {type: `string`, enum: [`blue`, `grey`, `red`]},
      'icon': `string`,
      'size': {type: `string`, enum: [`small`, `large`], default: `large`},
      'theme': {type: `string`, enum: THEMES},
    };
  }

  get config() {
    return Object.assign(super.config, {
      css,
      template,
    });
  }
});
